// =============================================
// Centralized Help Texts — Hebrew
// KipiKid - טקסטי עזרה לכל שדות המערכת
// tooltip = מוצג בריחוף על אייקון (?)
// helper = טקסט קבוע מתחת לשדה
// =============================================

// ===== ניהול ארגונים =====
export const adminOrgHelpTexts = {
  name: {
    tooltip: 'שם הארגון כפי שיופיע בכל המערכת — רשת, עירייה או גוף ממשלתי',
  },
  organizationType: {
    tooltip: 'סוג הארגון קובע את ההיררכיה: רשת (קבוצת גנים), עירייה (רשות מקומית) או ממשלתי',
  },
  contactName: {
    tooltip: 'איש הקשר הראשי של הארגון — לצורך תקשורת עם המערכת',
  },
  contactPhone: {
    tooltip: 'טלפון ליצירת קשר עם נציג הארגון',
    helper: 'פורמט: 050-000-0000',
  },
  contactEmail: {
    tooltip: 'כתובת מייל לקבלת עדכונים והתראות מהמערכת',
  },
  isActive: {
    tooltip: 'ארגון לא פעיל לא יופיע ברשימות ולא יאפשר כניסה למשתמשיו',
  },
};

// ===== הוספת מנהל לארגון =====
export const adminManagerHelpTexts = {
  firstName: {
    tooltip: 'שם פרטי של המנהל — יופיע בפרופיל המשתמש',
  },
  lastName: {
    tooltip: 'שם משפחה של המנהל',
  },
  phone: {
    tooltip: 'טלפון נייד — ישמש לקבלת התראות SMS',
    helper: '10 ספרות, לדוגמה: 0501234567',
  },
  email: {
    tooltip: 'כתובת מייל — אופציונלי, לשחזור סיסמה ועדכונים',
  },
  username: {
    tooltip: 'שם המשתמש לכניסה למערכת — חייב להיות ייחודי',
    helper: 'אותיות באנגלית ומספרים בלבד',
  },
  password: {
    tooltip: 'סיסמה ראשונית — המשתמש יתבקש לשנות אותה בכניסה הראשונה',
    helper: 'לפחות 8 תווים: אות גדולה, אות קטנה, ספרה ותו מיוחד',
  },
};

// ===== ניהול עובדים =====
export const adminStaffHelpTexts = {
  firstName: {
    tooltip: 'שם פרטי של העובד/ת',
  },
  lastName: {
    tooltip: 'שם משפחה של העובד/ת',
  },
  phone: {
    tooltip: 'טלפון נייד — חובה, ישמש לזיהוי ולהתראות',
    helper: '10 ספרות, לדוגמה: 0501234567',
  },
  email: {
    tooltip: 'כתובת מייל — אופציונלי',
  },
  username: {
    tooltip: 'שם משתמש לכניסה — ייחודי במערכת. אם לא יוזן ייווצר אוטומטית',
    helper: 'אותיות ומספרים בלבד. אם ריק — ייווצר אוטומטית',
  },
  password: {
    tooltip: 'סיסמה לכניסה ראשונה',
    helper: 'לפחות 8 תווים. המשתמש יתבקש לשנות בכניסה הראשונה',
  },
  role: {
    tooltip: 'תפקיד העובד/ת. גננת וסייעת משויכים לגן ספציפי, תפקידי ניהול (מנהל ומעלה) משויכים לארגון',
  },
  dayAssignment: {
    tooltip: 'בחר/י את ימי העבודה ואת הגן לכל יום. ניתן לשייך גנים שונים לימים שונים',
  },
  photo: {
    tooltip: 'תמונת פרופיל — אופציונלי. התמונה תוקטן ותדחס אוטומטית',
  },
};

// ===== ניהול גנים =====
export const adminKindergartenHelpTexts = {
  name: {
    tooltip: 'שם הגן כפי שיופיע לגננות ולהורים',
  },
  code: {
    tooltip: 'קוד ייחודי לגן — משמש להתחברות מהטאבלט',
    helper: 'אותיות ומספרים בלבד. הקוד יומר לאותיות גדולות אוטומטית',
  },
  city: {
    tooltip: 'עיר או יישוב בו ממוקם הגן',
  },
  address: {
    tooltip: 'כתובת מלאה — רחוב ומספר בית',
  },
  phone: {
    tooltip: 'טלפון ראשי של הגן',
    helper: 'פורמט: 050-000-0000 או 03-1234567',
  },
  email: {
    tooltip: 'כתובת מייל של הגן — אופציונלי',
  },
  director: {
    tooltip: 'שם מנהלת הגן — לתצוגה בלבד',
  },
  capacity: {
    tooltip: 'מספר ילדים מקסימלי — משמש לניהול קיבולת ולהתראות',
    helper: 'מספר שלם חיובי',
  },
  defaultOpenTime: {
    tooltip: 'שעת פתיחה ברירת מחדל — ניתן לדרוס ברמת ההגדרות',
    helper: 'פורמט: HH:MM (שעון 24)',
  },
  defaultCloseTime: {
    tooltip: 'שעת סגירה ברירת מחדל',
    helper: 'פורמט: HH:MM (שעון 24)',
  },
  notes: {
    tooltip: 'הערות פנימיות — לא מוצגות להורים',
  },
  photo: {
    tooltip: 'תמונת הגן — תוצג בפרופיל הגן. התמונה תדחס אוטומטית',
  },
};

// ===== ניהול מוצרים =====
export const adminProductHelpTexts = {
  name: {
    tooltip: 'שם המוצר כפי שיופיע בקטלוג ובהזמנות הגננות',
  },
  category: {
    tooltip: 'קטגוריית הוצאה — למיון ודיווח תקציבי',
  },
  unit: {
    tooltip: 'יחידת מידה של המוצר',
    helper: 'לדוגמה: יחידות, ק"ג, ליטר, מארז',
  },
  price: {
    tooltip: 'מחיר משוער ליחידה — לצורך תכנון תקציב',
    helper: 'בשקלים, לדוגמה: 15.90',
  },
  chargeable: {
    tooltip: 'מוצר מחויב ינוכה מהתקציב בעת רכישה. מוצר שאינו מחויב לא ינוכה',
  },
  active: {
    tooltip: 'מוצר לא פעיל לא יופיע בקטלוג להזמנות חדשות',
  },
};

// ===== ניהול קטגוריות =====
export const adminCategoryHelpTexts = {
  name: {
    tooltip: 'שם הקטגוריה — ישמש למיון הוצאות ומוצרים',
  },
  icon: {
    tooltip: 'שם אייקון מספריית Lucide — יוצג ליד שם הקטגוריה',
    helper: 'לדוגמה: utensils-crossed, package, book',
  },
  sortOrder: {
    tooltip: 'סדר הצגה — מספר נמוך יותר יוצג ראשון',
    helper: 'מספר שלם, 0 ומעלה',
  },
};

// ===== לוח שנה =====
export const adminCalendarHelpTexts = {
  eventName: {
    tooltip: 'שם האירוע או החג — יוצג בלוח השנה לגננות ולהורים',
  },
  eventType: {
    tooltip: 'סוג האירוע: חג, חול המועד, חופשה, או אחר',
  },
  startDate: {
    tooltip: 'תאריך תחילת האירוע',
  },
  endDate: {
    tooltip: 'תאריך סיום האירוע — כולל יום זה',
  },
  operationMode: {
    tooltip: 'מצב פעילות הגן: סגור (אין פעילות), רגיל (יום רגיל), או חלקי (שעות מקוצרות)',
  },
  notes: {
    tooltip: 'הערות פנימיות — לא מוצגות להורים',
  },
};

// ===== הגדרות מערכת =====
export const adminSettingsHelpTexts = {
  firstAlertDelay: {
    tooltip: 'זמן המתנה (בדקות) אחרי שעת ההגעה הצפויה לפני שליחת ההתראה הראשונה',
    helper: '1-60 דקות',
  },
  secondAlertDelay: {
    tooltip: 'זמן המתנה (בדקות) אחרי ההתראה הראשונה לשליחת ההתראה השנייה',
    helper: '1-60 דקות',
  },
  maxAlertDelay: {
    tooltip: 'זמן מקסימלי (בדקות) שבו תשלח התראה — לאחר מכן ההתראות נפסקות אוטומטית',
    helper: '1-240 דקות',
  },
  defaultOpenTime: {
    tooltip: 'שעת פתיחה ברירת מחדל לכל הגנים — ניתן לדרוס ברמת הגן',
    helper: 'פורמט: HH:MM',
  },
  defaultCloseTime: {
    tooltip: 'שעת סגירה ברירת מחדל',
    helper: 'פורמט: HH:MM',
  },
  displaySwitchTime: {
    tooltip: 'שעה שבה מסך הטאבלט עובר אוטומטית ממצב "טרם הגיעו" למצב "נמצאים בגן"',
    helper: 'פורמט: HH:MM',
  },
  latestArrivalTime: {
    tooltip: 'שעה אחרונה שבה ניתן לסמן הגעה בטאבלט — אחרי שעה זו הכפתור ננעל',
    helper: 'פורמט: HH:MM',
  },
  refreshInterval: {
    tooltip: 'תדירות רענון נתונים אוטומטי במסך הטאבלט',
    helper: '30-600 שניות, בקפיצות של 10',
  },
  language: {
    tooltip: 'שפת ברירת מחדל של ממשק המשתמש לגנים חדשים',
  },
};

// ===== כניסת הורים =====
export const parentLoginHelpTexts = {
  identifier: {
    tooltip: 'ניתן להתחבר עם טלפון, אימייל, או שם משתמש',
    helper: 'טלפון: 10 ספרות | אימייל: כתובת מלאה | שם משתמש: לפחות 3 תווים',
  },
  password: {
    tooltip: 'הסיסמה שהוגדרה בעת הרישום',
  },
  otp: {
    tooltip: 'קוד אימות בן 6 ספרות שנשלח לטלפון שלך ב-SMS',
    helper: 'הקוד תקף ל-5 דקות',
  },
  newPassword: {
    tooltip: 'בחר/י סיסמה חדשה וחזקה',
    helper: 'לפחות 8 תווים: אות גדולה, אות קטנה, ספרה ותו מיוחד (!@#$%...)',
  },
  confirmPassword: {
    tooltip: 'הזן/י שוב את הסיסמה החדשה לאימות',
    helper: 'חייב להיות זהה לסיסמה שהוזנה למעלה',
  },
};

// ===== אנשי קשר (הורים) =====
export const parentContactsHelpTexts = {
  contactPhone: {
    tooltip: 'מספר הטלפון של איש הקשר שברצונך להזמין',
    helper: '10 ספרות, לדוגמה: 0501234567',
  },
  contactEmail: {
    tooltip: 'כתובת מייל של איש הקשר — אופציונלי',
  },
  relation: {
    tooltip: 'יחס הקרבה לילד: הורה, קרוב משפחה, חבר, או אחר',
  },
  childrenSelection: {
    tooltip: 'בחר/י את הילדים שאיש הקשר יקבל עליהם התראות',
  },
};

// ===== תקציבים (גננות) =====
export const teacherBudgetHelpTexts = {
  name: {
    tooltip: 'שם מקור התקציב — יוצג בדוחות ובתצוגת הוצאות',
  },
  sourceType: {
    tooltip: 'סוג מקור התקציב: רשת, עירייה, ועד הורים, משרד החינוך, תרומה, או אחר',
  },
  totalBudget: {
    tooltip: 'סכום התקציב הכולל שהוקצה',
    helper: 'סכום בשקלים, לדוגמה: 50000',
  },
  periodStart: {
    tooltip: 'תאריך תחילת תקופת התקציב',
  },
  periodEnd: {
    tooltip: 'תאריך סיום תקופת התקציב',
  },
  notes: {
    tooltip: 'הערות חופשיות על מקור התקציב — אופציונלי',
  },
};

// ===== הוצאות (גננות) =====
export const teacherExpenseHelpTexts = {
  source: {
    tooltip: 'בחר/י את מקור התקציב ממנו תנוכה ההוצאה',
  },
  description: {
    tooltip: 'תיאור קצר של ההוצאה — מה נרכש ולמה',
  },
  amount: {
    tooltip: 'סכום ההוצאה הכולל',
    helper: 'סכום בשקלים, לדוגמה: 150.00',
  },
  date: {
    tooltip: 'תאריך ביצוע ההוצאה',
  },
  category: {
    tooltip: 'קטגוריית ההוצאה — למיון ודיווח',
  },
  notes: {
    tooltip: 'הערות נוספות — אופציונלי',
  },
};

// ===== סריקת חשבוניות (גננות) =====
export const teacherInvoiceHelpTexts = {
  upload: {
    tooltip: 'צלמי או העלי תמונה של חשבונית/קבלה. המערכת תזהה אוטומטית את הפרטים באמצעות OCR',
    helper: 'תמונה ברורה, JPEG או PNG, עד 5MB',
  },
  vendorName: {
    tooltip: 'שם העסק או הספק כפי שמופיע בחשבונית — ניתן לערוך ידנית',
  },
  vatNumber: {
    tooltip: 'מספר ח.פ. או עוסק מורשה — ניתן לערוך ידנית',
    helper: '9 ספרות',
  },
  invoiceNumber: {
    tooltip: 'מספר החשבונית — לצורך תיעוד ומעקב',
  },
  invoiceDate: {
    tooltip: 'תאריך החשבונית — לא תאריך הסריקה',
  },
  totalAmount: {
    tooltip: 'סכום כולל מע"מ כפי שמופיע בחשבונית',
    helper: 'סכום בשקלים',
  },
};

// ===== כניסה — מנהלים / מוקד =====
export const loginHelpTexts = {
  username: {
    tooltip: 'שם המשתמש שקיבלת מהמנהל/ת — אותיות באנגלית ומספרים',
  },
  password: {
    tooltip: 'הסיסמה שהוגדרה לך. ודא/י שהמקלדת באנגלית',
  },
};

// ===== כניסת גננת =====
export const teacherLoginHelpTexts = {
  username: {
    tooltip: 'שם המשתמש שקיבלת מהמנהל/ת',
  },
  password: {
    tooltip: 'הסיסמה שהוגדרה לך. שימי לב שהמקלדת באנגלית',
  },
};

// ===== רישום הורה =====
export const parentRegistrationHelpTexts = {
  phone: {
    tooltip: 'מספר הטלפון ישמש לאימות ולקבלת התראות',
    helper: '10 ספרות, לדוגמה: 0501234567',
  },
  otp: {
    tooltip: 'קוד אימות בן 6 ספרות שנשלח לטלפון שלך ב-SMS',
    helper: 'הקוד תקף ל-60 שניות',
  },
  firstName: {
    tooltip: 'שם פרטי — יופיע בפרופיל שלך וגלוי לגננת',
  },
  lastName: {
    tooltip: 'שם משפחה — יופיע בפרופיל שלך',
  },
  email: {
    tooltip: 'כתובת מייל — אופציונלי, לשחזור סיסמה וקבלת עדכונים',
  },
  language: {
    tooltip: 'שפת הממשק — ניתן לשנות בכל עת מההגדרות',
  },
  notificationMethod: {
    tooltip: 'בחר/י כיצד לקבל התראות על הילדים שלך',
  },
  address: {
    tooltip: 'כתובת מגורים — אופציונלי, לצורך חירום',
  },
};

// ===== שינוי סיסמה =====
export const changePasswordHelpTexts = {
  currentPassword: {
    tooltip: 'הסיסמה הנוכחית שלך — לאימות זהות',
  },
  newPassword: {
    tooltip: 'סיסמה חדשה חזקה — חייבת לעמוד בדרישות האבטחה',
    helper: 'לפחות 8 תווים: אות גדולה, אות קטנה, ספרה ותו מיוחד',
  },
  confirmPassword: {
    tooltip: 'הזן/י שוב את הסיסמה החדשה — חייבת להיות זהה',
  },
};

// ===== רשימות קניות (גננות) =====
export const teacherPurchaseHelpTexts = {
  listName: {
    tooltip: 'שם הרשימה — לזיהוי מהיר',
    helper: 'לדוגמה: רכישות שבועיות, ציוד למסיבה',
  },
  budgetSource: {
    tooltip: 'שייכי מקור תקציב — ההוצאות ינוכו ממנו בעת המרה',
  },
  notes: {
    tooltip: 'הערות חופשיות לרשימה — אופציונלי',
  },
  catalogSearch: {
    tooltip: 'חפשי מוצר מהקטלוג לפי שם — בחרי והוסיפי כמות',
  },
  adHocName: {
    tooltip: 'שם מוצר שלא נמצא בקטלוג — הוסיפי ידנית',
  },
  adHocQuantity: {
    tooltip: 'כמות יחידות לרכישה',
  },
  adHocUnit: {
    tooltip: 'יחידת מידה של המוצר',
    helper: 'לדוגמה: יח\', ק"ג, ליטר, מארז',
  },
  adHocPrice: {
    tooltip: 'מחיר משוער ליחידה — לצורך תכנון תקציב',
    helper: 'בשקלים',
  },
  adHocChargeable: {
    tooltip: 'מוצר מחויב ינוכה מהתקציב. מוצר לא מחויב (כמו תרומה) לא ינוכה',
  },
  convertSource: {
    tooltip: 'בחרי את מקור התקציב ממנו תנוכה ההוצאה. מוצגים יתרה ותקציב כולל',
  },
  receivedQuantity: {
    tooltip: 'כמות שהתקבלה בפועל — עשויה להיות שונה מהכמות שהוזמנה',
  },
};

// ===== לוח שנה גן =====
export const adminKgCalendarHelpTexts = {
  eventType: {
    tooltip: 'סוג האירוע: סגור (אין פעילות), אירוע מיוחד, או אחר',
  },
  startDate: {
    tooltip: 'תאריך תחילת האירוע',
  },
  endDate: {
    tooltip: 'תאריך סיום האירוע — כולל יום זה',
  },
  title: {
    tooltip: 'שם האירוע כפי שיוצג בלוח השנה',
  },
  notes: {
    tooltip: 'הערות פנימיות — לא מוצגות להורים',
  },
};

// ===== מוקד טלפוני =====
export const callCenterHelpTexts = {
  search: {
    tooltip: 'חיפוש לפי שם ילד, שם גן, או שם הורה',
  },
  statusFilter: {
    tooltip: 'סנן התראות לפי סטטוס: ממתין, פתוח, בטיפול, טופל, שגוי',
  },
  priorityFilter: {
    tooltip: 'סנן לפי רמת דחיפות: נמוכה, בינונית, גבוהה, קריטית',
  },
  resolutionNotes: {
    tooltip: 'תיעוד פתרון — פרט/י את תוצאת הטיפול ומה סוכם',
    helper: 'תאר/י בקצרה את הפעולה שבוצעה ותוצאתה',
  },
  resolutionType: {
    tooltip: 'סוג הפתרון: טופל (הילד הגיע/נמצא) או התראת שווא (לא היה צורך)',
  },
};
